var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6007 41.6601C60.6007 52.1207 52.1207 60.6008 41.6601 60.6008C31.1994 60.6008 22.7194 52.1207 22.7194 41.6601C22.7194 31.1995 31.1994 22.7195 41.6601 22.7195C52.1207 22.7195 60.6007 31.1995 60.6007 41.6601Z",
    fill: "#012584"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6601 69.824C57.2146 69.824 69.824 57.2146 69.824 41.6601C69.824 26.1056 57.2146 13.4962 41.6601 13.4962C26.1056 13.4962 13.4962 26.1056 13.4962 41.6601C13.4962 57.2146 26.1056 69.824 41.6601 69.824ZM41.6601 83.0001C64.4915 83.0001 83.0001 64.4915 83.0001 41.6601C83.0001 18.8286 64.4915 0.320068 41.6601 0.320068C18.8286 0.320068 0.320068 18.8286 0.320068 41.6601C0.320068 64.4915 18.8286 83.0001 41.6601 83.0001Z",
    fill: "#0072CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.a31489c5658cd7eb289bb31c78016178.svg";
export { ForwardRef as ReactComponent };